/**
 * Created by perl on 21/03/16.
 */
angular.module('common.filter.specialCharacterToHtml', [])
    .filter('specialCharacterToHtml', function () {
        return function (descriptionWithSpecialCharacters) {
            if (!descriptionWithSpecialCharacters) {
                return;
            }
            var str;
            str = descriptionWithSpecialCharacters.toString().replace(/\|/g, "&nbsp;")
                .replace(/!<P>!/g, "<br>")
                .replace(/<P>/g, "<br>")
                .replace(/!1!/g, "<br>")
                .replace(/\n/g, "<br>")
                .replace(/\t/g, "&nbsp;&nbsp;&nbsp;&nbsp;")
                .replace(/\$(.)/g, "<sup>$1</sup>")
                .replace(/\@(.)/g, "<sub>$1</sub>")
                .replace(/\|/g, "&nbsp;")
                .replace(/!o!/g, "&deg;")
                .replace(/![xX]!/g, "x") // ACSMNT-3871: "times" sign displayed with a "x" instead of a dot as a symbol
                .replace(/!%!/g, "&permil;")
                .replace(/!>=!/g, "&ge;")
                .replace(/&#64;/g, "&commat;");
            return str;
        };
    })
;



// WEBPACK FOOTER //
// ./app/common/filter/special-character-to-html-filter.js